<app-page-container maxHeight>
  <app-header [paddingBottom]="false" appTitle="Contratos">
    <div class="botao__voltar">
      <app-botao-voltar class="c-header__button"></app-botao-voltar>
    </div>
    <app-card class="c-card" [data]="dadosCard"></app-card>
    <app-botoes-files [disableXLSX]="true"></app-botoes-files>
  </app-header>
  <div class="c-table-container">
    <table class="c-table-container__table" mat-table [dataSource]="equipamentos.registros">
      <ng-container matColumnDef="modelo">
        <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
          <div class="u-border-none c-table-container__table__header-text">Modelo</div>
        </th>
        <td class="c-table-container__table__cell" mat-cell *matCellDef="let item">{{item.modelo || "Sem dados"}}</td>
      </ng-container>
      <ng-container matColumnDef="numPat">
        <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
          <div class="c-table-container__table__header-text">Patrimônio</div>
        </th>
        <td class="c-table-container__table__cell" mat-cell *matCellDef="let item">{{item.numPat || "Sem dados"}}</td>
      </ng-container>
      <ng-container matColumnDef="numSerie">
        <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
          <div class="c-table-container__table__header-text">Nº de Série</div>
        </th>
        <td class="c-table-container__table__cell" mat-cell *matCellDef="let item">{{item.numSerie}}</td>
      </ng-container>
      <ng-container matColumnDef="temAcessorios">
        <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
          <div class="c-table-container__table__header-text">Acessórios</div>
        </th>
        <td class="c-table-container__table__cell" mat-cell *matCellDef="let item"> <app-listagem-acessorios
            [codContrato]="item.codigoContr" [numSerie]="item.numSerie"></app-listagem-acessorios>
        </td>
      </ng-container>
      <ng-container matColumnDef="temEquipamentoBackup">
        <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
          <div class="c-table-container__table__header-text">Backup</div>
        </th>
        <td class="c-table-container__table__cell" mat-cell *matCellDef="let item">{{item.backup ? "Sim" : "Não"}}</td>
      </ng-container>
      <ng-container matColumnDef="dataInstalacao">
        <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
          <div class="c-table-container__table__header-text">Data de instalação</div>
        </th>
        <td class="c-table-container__table__cell" mat-cell *matCellDef="let item"> {{(item.dataInstalacao
          | date: "dd/MM/yyyy") || "Sem dados"
          }} </td>
      </ng-container>
      <ng-container matColumnDef="endereco">
        <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
          <div class="c-table-container__table__header-text">Endereço</div>
        </th>
        <td class="c-table-container__table__cell" mat-cell *matCellDef="let item"> {{item.endereco ||
          "Sem dados"}} </td>
      </ng-container>
      <ng-container matColumnDef="nomeDepartamento">
        <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
          <div class="c-table-container__table__header-text">Departamento</div>
        </th>
        <td class="c-table-container__table__cell" mat-cell *matCellDef="let item"> {{item.nomeDepartamento ||
          "Sem dados"}} </td>
      </ng-container>
      <tr class="c-table-container__table__header-row" mat-header-row *matHeaderRowDef="colunasVisiveis; sticky: true">
      </tr>
      <tr mat-row *matRowDef="let row; columns: colunasVisiveis;"></tr>
    </table>
  </div>
  <app-paginacao nomeDaLista="equipamentos" [(dados)]="equipamentos" (dadosChange)="obterEquipamentos()"
    *ngIf="this.equipamentos.registros.length !== 0"></app-paginacao>
</app-page-container>
